import type { MedicationOrderInsight } from '../types/medicationAI'

export function parseMedicationOrderInsights(text: string): MedicationOrderInsight {
  const empty: MedicationOrderInsight = { explanations: [], rankedAlternatives: [] }
  try {
    const trimmed = text.trim()
    const jsonMatch = trimmed.match(/\{[\s\S]*\}/)
    const raw = jsonMatch ? jsonMatch[0] : trimmed
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return empty

    const explanations = Array.isArray(parsed.explanations)
      ? parsed.explanations
          .filter((e: any) => e && typeof e.alertId === 'string' && typeof e.briefSummary === 'string')
          .map((e: any) => ({
            alertId: e.alertId,
            briefSummary: e.briefSummary,
            clinicalDetail: typeof e.clinicalDetail === 'string' ? e.clinicalDetail : undefined,
          }))
      : []

    const rankedAlternatives = Array.isArray(parsed.rankedAlternatives)
      ? parsed.rankedAlternatives
          .filter((r: any) => r && typeof r.referenceDrugId === 'string' && typeof r.rationale === 'string')
          .map((r: any) => ({
            referenceDrugId: r.referenceDrugId,
            rationale: r.rationale,
          }))
      : []

    return {
      explanations,
      rankedAlternatives,
      educationalNotes:
        typeof parsed.educationalNotes === 'string' ? parsed.educationalNotes : undefined,
    }
  } catch (e) {
    console.error('[MedicationOrderAI] Parse failed:', e)
    return empty
  }
}
